import type { Social } from '.';
import { encodePacket } from '../utils/encoder';

export const socialModifiers = ({ social }: Social.MutableState) => ({
  recordInvites(friendIds: string[], timeSent: number) {
    friendIds.forEach((friendId) => {
      const maskedId = encodePacket(friendId);
      social.invites[maskedId] = {
        timeSent,
        referralRewardClaimed: false,
      };
    });
  },

  setAllReferralRewardsClaimed(): number {
    let claimCount = 0;
    Object.values(social.invites).forEach((invite) => {
      if (!invite.referralRewardClaimed) {
        invite.referralRewardClaimed = true;
        claimCount += 1;
      }
    });

    return claimCount;
  },
});
